export const PROJECTS_PER_PAGE = 10;
export const POSTS_PER_PAGE = 100;
